import { onBeforeUnmount } from 'vue'
import type { GridCol } from '~~/types/orgGrid'
import { useBreadcrumbLabelsStore } from '~~/stores/breadcrumbLabels'
import { useFormatLabel } from '~/composables/ui/useFormatLabel'

export function useDirectionPageBreadcrumbPreview() {
  const labelsStore = useBreadcrumbLabelsStore()
  const { formatLabel } = useFormatLabel()

  function setBreadcrumbDomainePreview(col: GridCol) {
    const label = formatLabel(col?.header?.label) || col?.header?.libLong?.trim() || ''
    if (label) labelsStore.setHoverPreviewDomaine({ label })
  }

  function clearBreadcrumbDomainePreview() {
    labelsStore.setHoverPreviewDomaine(null)
  }

  onBeforeUnmount(clearBreadcrumbDomainePreview)

  return {
    setBreadcrumbDomainePreview,
    clearBreadcrumbDomainePreview,
  }
}
